import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import MenuPlannerSelectHeader from '@component/view/MenuPlannerSelectHeader.vue'
import MenuPlannerSelectShow from '@component/view/MenuPlannerSelectShow.vue'
import MenuPlannerSelectEdit from '@component/view/MenuPlannerSelectEdit.vue'

if ($('#menu-planner-select').length) {
  Vue.use(VueResource)
  Vue.use(Vuex)
  const routes = [
    {
      path: '/',
      name: 'menu-planner-home',
      components: { header: MenuPlannerSelectHeader },
      props: { header: true },
    },
    {
      path: '/show/:date/:brand',
      name: 'menu-planner-select-show',
      components: {
        header: MenuPlannerSelectHeader,
        body: MenuPlannerSelectShow,
      },
      props: {
        header: true,
        body: true,
      },
    },
    {
      path: '/edit/:date/:brand/:showDate',
      name: 'menu-planner-select-edit',
      components: {
        header: MenuPlannerSelectHeader,
        body: MenuPlannerSelectEdit,
      },
      props: {
        header: true,
        body: true,
      },
    },
  ]

  const store = new Vuex.Store({
    state: {
      availableBrands: null,
    },
    mutations: {
      setAvailableBrands(state, brands) {
        state.availableBrands = brands
      },
    },
  })

  const router = new VueRouter({
    routes,
  })

  Vue.use(VueRouter)

  new Vue({
    router,
    store,
  }).$mount('#menu-planner-select')
}
